export function createAsyncTaskPanelSession() {
  return { status: 'idle', projectPk: null }
}

export function shouldResetAsyncTaskTransitionHistory(session, nextProjectPk) {
  if (session?.status !== 'tracking') return true
  return String(session.projectPk ?? '') !== String(nextProjectPk ?? '')
}

export function transitionAsyncTaskPanelSession(session = createAsyncTaskPanelSession(), event = {}) {
  if (event.type === 'start') {
    return {
      status: 'tracking',
      projectPk: event.projectPk ?? null,
    }
  }

  if (event.type === 'terminal-success' || event.type === 'stop' || event.type === 'logout') {
    return createAsyncTaskPanelSession()
  }

  return session
}

export function startAsyncTaskPanelSession(session, projectPk) {
  return transitionAsyncTaskPanelSession(session, { type: 'start', projectPk })
}

export function stopAsyncTaskPanelSession(session) {
  return transitionAsyncTaskPanelSession(session, { type: 'stop' })
}
